"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSizeFromWidth = exports.bp = exports.bpSizes = exports.breakpoints = void 0;
exports.breakpoints = {
    mobile: { min: 0, max: 600 },
    medium: { min: 601, max: 1023 },
    large: { min: 1024, max: null }
};
exports.bpSizes = ["mobile", "medium", "large"];
var getWidthCondition = function (minMax, size) {
    var pixels = typeof size === "number" ? size : exports.breakpoints[size][minMax];
    return pixels ? "(" + minMax + "-width: " + pixels + "px)" : null;
};
var constructMediaQuery = function () {
    var conditions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        conditions[_i] = arguments[_i];
    }
    var validConditions = conditions.filter(Boolean);
    return "@media " + validConditions.join(" and ");
};
var min = function (size) {
    return constructMediaQuery(getWidthCondition("min", size));
};
var max = function (size) {
    return constructMediaQuery(getWidthCondition("max", size));
};
var only = function (size) {
    return constructMediaQuery(getWidthCondition("min", size), getWidthCondition("max", size));
};
var each = function (cssProperty, responsiveValue, suffix, transform) {
    if (transform === void 0) { transform = function (value) { return value; }; }
    if (typeof responsiveValue === "object") {
        return exports.bpSizes
            .map(function (bpSize) {
            var mq = only(bpSize);
            var value = responsiveValue[bpSize];
            return mq + " { " + cssProperty + ": " + transform(value) + suffix + "; }";
        })
            .join("\n");
    }
    else {
        return cssProperty + ": " + transform(responsiveValue) + suffix + ";";
    }
};
exports.bp = { min: min, max: max, only: only, each: each };
var getSizeFromWidth = function (widthPx) {
    return exports.bpSizes.reduce(function (matchingSize, bpSize) {
        var breakpoint = exports.breakpoints[bpSize];
        var min = breakpoint.min;
        var max = breakpoint.max;
        if ((!min || widthPx >= min) && (!max || widthPx <= max)) {
            return bpSize;
        }
        else {
            return matchingSize;
        }
    }, "large");
};
exports.getSizeFromWidth = getSizeFromWidth;
